
import React, { useEffect, useRef, useState } from "react";
import "./homebutton.scss";




const HomeButton = React.memo(({ onClick, disabled, text, style, href }) => {

        return (
            <a href= {href} className="homebutton" onClick={onClick} disabled={disabled} style={style}>                <label className="trigger">{text}</label>
                <div className="dots">
                    <div className="dot"></div>
                    <div className="dot"></div>
                    <div className="dot"></div>
                </div>
            </a>
        );
    
})

export default HomeButton;